import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NotificationComponent } from 'src/app/shared/components/notification/notification.component';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService{
  constructor(
    private dialog: MatDialog,
    private loader: LoaderService,
    private translate: TranslateService,
    private router: Router
  ) { }

  handleRcodeError(data: any): void {
    const errorMessage = data?.rmsg[0]?.errorText || 'Something went wrong';
    let _dialogRef = this.dialog.open(NotificationComponent, {
      disableClose: true,
      panelClass: 'dialog-error-class',
      data: {
        block: 'error',
        errorReferenceNumber: data?.rObj?.ErrorReferenceNumber || '',
        errorMessage,
      }
    });
    _dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.router.navigate(['/home']).then(() => { this.router.navigate(['quotation/get-quote' ]); })
      }
    });
  }

  hasOverlappingPassportDatesError(data: any): void {
    const errorMessage = data?.rmsg[0]?.errorText;
    let _dialogRef = this.dialog.open(NotificationComponent, {
      disableClose: true,
      panelClass: 'dialog-error-class',
      data: {
        block: 'hasOverlappingPassportDatesError',
        errorReferenceNumber: data?.rObj?.errorCode || '',
        errorMessage,
      }
    });
    _dialogRef.afterClosed().subscribe(result => {
      // if(result){
      //   this.router.navigate(['/']).then(() => { this.router.navigate(['quotation/get-quote' ]); })
      // }
    });
  }

  handleStatusError(error: any): void {
    if (
      error.status !== 401 &&
      error.status !== 403 &&
      error.status !== 404 &&
      error.status !== 500
    ) {
      const errorMessage = error?.rmsg[0]?.errorText || 'Something went wrong';
      let _dialogRef = this.dialog.open(NotificationComponent, {
        disableClose: true,
        panelClass: 'dialog-error-class',
        data: {
          block: 'error',
          errorReferenceNumber: error?.rObj?.ErrorReferenceNumber || '',
          errorMessage,
        }
      });
      _dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.router.navigate(['/']).then(() => { this.router.navigate(['quotation/get-quote' ]); })
        }
      });
    } else {
      this.handleNonError(error)
    }
  }

  handleNonError(error: any) {
    switch (error.status) {
      case 404:
        if (!this.router.url.endsWith('/login')) {
          this.router.navigate(['/error/error-status-404']);
        }
        break;
      case 403:
        this.router.navigate(['/error/error-status-403']);
        break;
      case 500:
        if (error.error.transactionRef) {
          this.router.navigate(['/error/error-status-500', error.error.transactionRef]);
        } else {
          this.router.navigate(['/error/error-status-500']);
        }
        break;
      default:
        console.error('Unhandled error status:', error.status);
    }
  }
  
  internalError(){
    this.router.navigate(['/error/internal-error']);
  }

}

